<template>
    <!-- Confirmation Modal -->
    <div class="modal fade" :id="props.id" tabindex="-1" aria-labelledby="confirmModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered popOutModal">
            <div class="modal-content" :id="props.contentId">
                <div class="modal-body d-flex flex-column py-4 align-items-center justify-content-between">
                    <i class="bi w-auto h-auto fs-large" :class="icon_class"></i>
                    <p class="my-2 fs-3">{{ title }}</p>
                    <p class="my-2 text-secondary text-center" v-html="info_text"></p>
                    <div class="mt-3 d-flex gap-3">
                        <button class="btn btn-outline-dark" data-bs-dismiss="modal">Cancel</button>
                        <button class="btn py-7"
                            :class="btn_color !== undefined && btn_color != null && btn_color.trim() !== '' ? btn_color : 'btn-warning'"
                            v-ripple @click="emits('performAction')" >{{ btn_text }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import Modal from "bootstrap/js/dist/modal";

const props = defineProps({
    title: String,
    info_text: String,
    btn_text: String,
    icon_class: String,
    btn_color: String,
	id: {
		type: String,
		default: 'confirmModal'
	},
	contentId: {
		type: String,
		default: 'confirmModalContent'
	}
});

const emits = defineEmits(['performAction', 'closeModal']);
const modal = ref(null);

onMounted(() => {
    var modalEl = document.getElementById(props.id);
    modal.value = Modal.getOrCreateInstance(modalEl);
    modal.value.show();

    modalEl.addEventListener('hide.bs.modal', function (event) {
        modalEl.querySelector('.modal-dialog').classList.add('closing');
        setTimeout(() => {
            modalEl.querySelector('.modal-dialog').classList.remove('closing');
        }, 500)
        emits('closeModal');
    });
});

const close = async () => {
    if (modal.value) {
        modal.value.hide();
    }
}

defineExpose({
    close
});
</script>